// Path icon nét lấy từ board Mint-Hub (bộ `ic`).
export const IC = {
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z M12 1v2 M12 21v2 M4.2 4.2l1.4 1.4 M18.4 18.4l1.4 1.4 M1 12h2 M21 12h2 M4.2 19.8l1.4-1.4 M18.4 5.6l1.4-1.4',
  moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
  team: 'M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0 M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2 M16 3.13a4 4 0 0 1 0 7.75 M21 21v-2a4 4 0 0 0 -3 -3.85',
  userX: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M17 8l5 5 M22 8l-5 5',
  wifiOff: 'M2 2l20 20 M8.5 16.4a5 5 0 0 1 7 0 M5 12.9a10 10 0 0 1 5.2-2.8 M19 12.9a10 10 0 0 0-2.3-1.6 M1.4 9a15 15 0 0 1 4.3-2.6 M22.6 9A15 15 0 0 0 10.7 5 M12 20h.01',
  check: 'M20 6 9 17l-5-5',
  next: 'M5 12h14 M13 6l6 6-6 6',
  arrow: 'M7 17 17 7 M8 7h9v9',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9 M10.3 21a1.9 1.9 0 0 0 3.4 0',
  q: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
  user: 'M20 21a8 8 0 0 0-16 0 M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z',
  cancel: 'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0 M5.7 5.7l12.6 12.6',
  help: 'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0 M12 17l0 .01 M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4',
  grid: 'M3 12l3 0 M12 3l0 3 M7.8 7.8l-2.2 -2.2 M16.2 7.8l2.2 -2.2 M7.8 16.2l-2.2 2.2 M12 12l9 3l-4 2l-2 4l-3 -9',
} as const;

export function Stroke({ d, size = 18, w = 1.9 }: { d: string; size?: number; w?: number }) {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d={d} />
    </svg>
  );
}
